var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noDataContainer",style:({ height: _vm.height + 'px' })},[_c('span',[_vm._v(_vm._s(_vm.$t("ifm.nd")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }